var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit($event)
              }
            }
          },
          [_c("buttons", { attrs: { top: "" } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("h4", { staticStyle: { display: "inline-block" } }, [
          _vm._v("Languages")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Please add the languages you operate in.")]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { stlye: "position: relative; " } },
          [
            _vm.languageModalVisable
              ? _c("multiSelectModal", {
                  attrs: {
                    property: "provider_languages",
                    propertyName: "language",
                    search: true,
                    alphabet: true
                  },
                  on: {
                    close: function($event) {
                      return _vm.toggleLanguageModal()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.getProperty(["provider_languages"]), function(
            language,
            index
          ) {
            return _c("div", { staticClass: "badge prop-badge" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getFirst10(language["language"].name)) +
                  "\n          "
              ),
              _c(
                "button",
                {
                  staticClass: "close-badge",
                  staticStyle: {
                    "padding-left": "7px",
                    "border-style": "hidden",
                    "margin-top": "0px",
                    "line-height": "0.4"
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.deleteProperty(index, "provider_languages")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "20px", color: "#d82d14" },
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v("×")]
                  )
                ]
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-default btn-create",
            staticStyle: { "margin-left": "0px", "margin-top": "10px" },
            on: {
              click: function($event) {
                return _vm.toggleLanguageModal()
              }
            }
          },
          [_vm._v("\n        Add language\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("h4", { staticStyle: { display: "inline-block" } }, [
          _vm._v("Currency")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Please add the currencies you disburse funds in.")]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { stlye: "position: relative; " } },
          [
            _vm.currencyModalVisable
              ? _c("multiSelectModal", {
                  attrs: {
                    property: "provider_currencies",
                    propertyName: "currency",
                    search: true,
                    alphabet: true
                  },
                  on: {
                    close: function($event) {
                      return _vm.toggleCurrencyModal()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.getProperty(["provider_currencies"]), function(
            currency,
            index
          ) {
            return _c("div", { staticClass: "badge prop-badge" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getFirst10(currency["currency"].name)) +
                  "\n          "
              ),
              _c(
                "button",
                {
                  staticClass: "close-badge",
                  staticStyle: {
                    "padding-left": "7px",
                    "border-style": "hidden",
                    "margin-top": "0px",
                    "line-height": "0.4"
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.deleteProperty(index, "provider_currencies")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "20px", color: "#d82d14" },
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v("×")]
                  )
                ]
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-default btn-create",
            staticStyle: { "margin-left": "0px", "margin-top": "10px" },
            on: {
              click: function($event) {
                return _vm.toggleCurrencyModal()
              }
            }
          },
          [_vm._v("\n        Add currency\n      ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit($event)
          }
        }
      },
      [_c("buttons")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-629f6cce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-629f6cce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/localePage.vue
// module id = 193
// module chunks = 0